import React, { useState, useEffect } from "react";
import "../../globals.css";
import { FAQ } from "../../../components/FAQ";
import { Hero } from "../../../components/Hero";
import { ScientificallyBackedSection } from "../../../components/ScientificallyBackedSection";
import { References } from "../../../components/References";
import { JoinSubscribersSection } from "../../../components/JoinSubscribersSection";
import { TimelineSection } from "../../../components/TimelineSection";
import { Ingredients } from "../../../components/Ingredients";
import { Testimonials } from "../../../components/Testimonials";
import { HarvardStudy } from "../../../components/HarvardStudy";
import { Versus } from "../../../components/Versus";
import { ProductPicker } from "../../../components/ProductPicker";
import { Experience } from "../../../components/Experience";
import { TestimonialsSmall } from "../../../components/TestimonialsSmall";
import { TextImageSection } from "../../../components/TextImageSection";
import { Header } from "../../../components/Header";
import { Footer } from "../../../components/Footer";
import { InfoSectionWrapper } from "../../../components/InfoSection/InfoSectionWrapper.tsx";
import { ProgressLine } from "../../../components/ProgressLine";
import { LoadingOverlay } from "../../../components/LoadingOverlay";

const V1 = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsLoading(false);
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <ScientificallyBackedSection />
      <InfoSectionWrapper sectionKey="pp_v7_info_section_1" />
      <TextImageSection />
      <Experience />
      <TestimonialsSmall />
      <InfoSectionWrapper sectionKey="pp_v7_info_section_2" />
      <TimelineSection />
      <JoinSubscribersSection />
      <InfoSectionWrapper
        sectionKey="pp_v7_special_deal_section"
        lineComponent={<ProgressLine />}
      />
      <ProductPicker setIsLoading={setIsLoading} />
      <InfoSectionWrapper sectionKey="pp_v7_info_section_3" />
      <Versus />
      <Ingredients />
      <HarvardStudy />
      <Testimonials />
      <FAQ />
      <References />
      <Footer />
      <LoadingOverlay isLoading={isLoading} />
    </div>
  );
};

export default V1;
